import { IForm, State } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { autoinject } from 'aurelia-framework';
import { apiCall } from 'app/shared/lib/api/api';
import { AdmissionCareDayService } from 'app/um/services/admission-care-day-service';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { Toaster } from 'app/shared/lib/toaster';
import { I18N } from 'aurelia-i18n';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class SaveStatusHistory implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object public statusHistory: UM.AdmissionCareDayStatusHistory = {};

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        public state: State,
        private readonly admissionCareDayService: AdmissionCareDayService,
        private readonly logger: AppLogger,
        private readonly i18n: I18N,
        private readonly toaster: Toaster) {

        this.logger.source = this;
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return this.updateStatusHistory();
    }

    public reset(): void {
        this.statusHistory = {};
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async updateStatusHistory(): Promise<boolean> {
        if(!this.statusHistory.id) { return false; }

        let isSuccessful = false;
        try {
            this.state.beginSave();
            const response = await this.admissionCareDayService.updateStatusHistory(this.statusHistory);
            isSuccessful = response.isSuccessful;
        }
        catch(error) {
            throw error;
        }
        finally {
            if(isSuccessful) {
                this.toaster.info().message(this.i18n.tr('ui:messages.events.updated', { what: '$t(um:auth.$)' })).show();
            } else {
                this.toaster.error().message(this.i18n.tr('ui:labels.updating', { what: '$t(um:auth.$)' })).show();
            }
            this.state.endSave();
            return isSuccessful;
        }
    }
}
